// extracted by mini-css-extract-plugin
export default {"wrapper":"ReceiptColumn_wrapper--GxS","wrapperJustifyStart":"ReceiptColumn_wrapperJustifyStart--lTf","button":"ReceiptColumn_button--K_U"};